<template>
  <div class="deskblock">
    <h3>快捷方式</h3>
    <Row :gutter="15" style="margin-top: 20px">
      <Col
        class="wuliuicon"
        span="8"
        v-for="(item, index) in items"
        :key="index"
      >
        <a :class="{ disabled: item.disabled }" @click="goto(item)"
          ><Icon :type="item.icon"></Icon>
          <p>{{ item.title }}</p></a
        >
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          icon: "md-pin",
          title: "车辆定位",
          path: "/carLocate",
          disabled: true,
        },
        {
          icon: "md-car",
          title: "车辆轨迹",
          path: "/locus",
          disabled: true,
        },
        {
          icon: "logo-buffer",
          title: "风控报告",
          path: "/anaReport",
          disabled: true,
        },
        {
          icon: "md-pie",
          title: "数据看板",
          name:'数据看板',
          now:0,
          id:0,
          path: "/control",
          disabled: false,
        },
        {
          icon: "md-document",
          title: "用车申请",
          path: "/shenqing",
          disabled: true,
        },
        {
          icon: "ios-switch",
          title: "趟次记录",
          path: "/tangcichaxun",
          disabled: true,
        },
      ],
    };
  },
  methods: {
    getMenu() {
      var mm = this.$store.state.nav;
var m=[];
for (let i = 0; i < mm.length; i++) {
  if (mm[i].type==1) {
    m.push(mm[i])
  }
  
}
      var t = this.items;

      for (let i = 0; i < m.length; i++) {
        if (m[i].childList.length > 0) {
          for (let j = 0; j < m[i].childList.length; j++) {
            m[i].childList[j].now = i;
            for (let z = 0; z < t.length; z++) {
              if (t[z].path == m[i].childList[j].link) {
                t[z].disabled = false;
                t[z].now = i;
                t[z].name = m[i].childList[j].name;
                t[z].id = m[i].childList[j].id;
              }
            }
          }
        }
      }
    },
    goto(v) {
      if (v.disabled) {
        return;
      } else {
        this.$router.push({
          path: v.path,
          query: { now: v.now },
        });
      }
      var row = {
        name: v.name,
        link: v.path,
        now: v.now,
        id: v.id,
      };
      var result = this.$store.state.topMenuList.some((item) => {
        if (item.id == row.id) {
          return true;
        }
      });
      if (!result) {
        //row.now = this.$route.query.now;
        this.$store.state.topMenuList.push(row);
      }
    },
  },
  computed: {
    nav() {
      this.getMenu();
    },
  },
  watch: {
    nav(m) {},
  },
};
</script>
<style lang="">
.wuliuicon i {
  font-size: 48px;
  margin-bottom: 10px;
  color: #3397e3;
}
.wuliuicon {
  text-align: center;
}
.wuliuicon a {
  display: block;
  padding: 20px 4px;
}
.wuliuicon a:hover {
  background: #e7ecff;
}
.wuliuicon a.disabled {
  cursor: no-drop;
}
</style>



// WEBPACK FOOTER //
// src/components/workDesk/block3.vue